import { render } from "./MedicationDetail.vue?vue&type=template&id=3c548165&scoped=true"
import script from "./MedicationDetail.vue?vue&type=script&lang=js"
export * from "./MedicationDetail.vue?vue&type=script&lang=js"

import "./MedicationDetail.vue?vue&type=style&index=0&id=3c548165&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c548165"]])

export default __exports__